/* eslint-disable @next/next/no-img-element */
'use client'
import { usePathname, useSearchParams } from 'next/navigation'
import { useMemo } from 'react'
import { CurrentFilterTag } from './current-filter-tag'
import { getVND } from '@/utils/helpers'

interface Props {
  listProduct: IProducts | undefined
}

const ProductFilterTag = ({}: Props) => {
  const searchParamsClient = useSearchParams()
  const filterParam = searchParamsClient?.toString() || ''
  const pathname = usePathname()
  const selectedFilters = useMemo(() => {
    const allowList = ['price', 'size', 'category_uid', 'color', 'search']
    const params = new URLSearchParams(filterParam)

    // Lấy entries giống searchParamsClient.entries()
    const entries = Array.from(params.entries())

    const filters: { attributeCode: string; value: string }[] = []

    for (const [key, value] of entries) {
      if (!allowList.includes(key)) continue
      // Xử lý riêng cho filter price
      if (key === 'price') {
        const [min, max] = value.split('-').map(Number)
        filters.push({
          attributeCode: key,
          value: getVND(min) + ' - ' + getVND(max),
        })
        continue
      }

      const values = value.split(',') // tách các value kiểu "Đỏ,Vàng"
      filters.push(...values.map((val) => ({ attributeCode: key, value: val })))
    }

    return filters
  }, [filterParam])

  const handleRemoveFilter = (tag: { attributeCode: string; value: string }) => {
    const { attributeCode, value } = tag
    const newSearchParams = new URLSearchParams(filterParam)

    // Xử lý riêng cho filter price - chỉ cần xóa toàn bộ param
    if (attributeCode === 'price') {
      newSearchParams.delete(attributeCode)
    } else {
      // Xử lý các filter khác như cũ
      const params = new URLSearchParams(filterParam)
      const currentValues = params.get(attributeCode)?.split(',') || []
      const updatedValues = currentValues.filter((v) => v !== value)

      if (updatedValues.length > 0) {
        newSearchParams.set(attributeCode, updatedValues.join(','))
      } else {
        newSearchParams.delete(attributeCode)
      }
    }

    window.history.pushState({}, '', `${pathname}?${newSearchParams.toString()}`)
  }

  return (
    <>
      <CurrentFilterTag listCurrentTagsFilter={selectedFilters} handleRemoveTag={handleRemoveFilter} />
    </>
  )
}

export default ProductFilterTag
